import React, { useState, useEffect } from "react";
import {
  Table,
  Pagination,
} from "react-bootstrap";
import { FiHome, FiChevronRight, FiFileText } from "react-icons/fi";
import { Link, } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getNotice } from "../../store/slices/notice";
import { toast } from "react-hot-toast";

export default function TeacherNotices() {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);

  const fetchNotice = () => {
    setIsLoading(true);
    const item = { usertype: 1 };
    dispatch(getNotice(item))
      .unwrap()
      .then((res) => {
        const notices = res?.data || [];
        setData(notices);
        setTotalData(res?.totalDataCount || notices.length);
      })
      .catch(({ message }) => {
        console.error(message);
        toast.error("Failed to fetch Noticedetails ");
        setData([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchNotice();
  }, []);

  // total page
  const totalPages = Math.ceil(totalData / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = data.slice(startIndex, startIndex + itemsPerPage);

  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">


          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/teacher/home">
                <FiHome style={{ color: "white", marginTop: "-4px" }} />
              </Link>
            </div>

            <FiChevronRight className="separator" />
            <span className="active">Notice</span>
          </div>

          <div className="d-flex align-items-center gap-2 flex-wrap">
          </div>

        </div>
      </div>
      <div className="staff-card">



        {/* Table */}
        <div className="table-responsive">
          <Table className="staff-table align-middle">
            <thead>
              <tr>

                <th className="text-center">#</th>
                <th className="text-center">Date</th>
                <th className="text-center">Details</th>

                <th className="text-center">File</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.map((s, i) => (
                <tr key={s._id}>

                  <td className="text-center">{i + 1}</td>

                  <td className="text-center">
                    {new Date(s.date).toLocaleDateString("en-GB")}
                  </td>

                  <td className="text-center">{s.description}</td>

                  <td className="text-center">
                    {s.files?.length > 0 ? (
                      <FiFileText
                        size={18}
                        style={{ cursor: "pointer", color: "#2563eb" }}
                        onClick={() => window.open(s.files[0], "_blank")}
                      />
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))}

              {!isLoading && paginatedData.length === 0 && (
                <tr>
                  <td
                    colSpan="6"
                    className="text-center"

                  >
                    No notices found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="d-flex justify-content-end my-3">
          <Pagination className="mb-0">

            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            />

            {Array.from({ length: totalPages }, (_, index) => {
              const page = index + 1;

              // Show first page, last page, and pages around current page
              if (
                page === 1 ||
                page === totalPages ||
                (page >= currentPage - 1 && page <= currentPage + 1)
              ) {
                return (
                  <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </Pagination.Item>
                );
              }

              // Left dots
              if (page === currentPage - 2) {
                return <Pagination.Ellipsis key={`left-${page}`} disabled />;
              }

              // Right dots
              if (page === currentPage + 2) {
                return <Pagination.Ellipsis key={`right-${page}`} disabled />;
              }

              return null;
            })}

            <Pagination.Next
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage((p) => p + 1)}
            />

          </Pagination>
        </div>
      </div>
    </>
  );
}
